export default __webpack_public_path__ + "static/cnn_logo_shadowed-48fb4d462e51cb71d5b166e81535e117.png";